export const apiVersion =
  process.env.NEXT_PUBLIC_SANITY_API_VERSION || '2025-06-05'

// ВАЖНО: Эти переменные должны быть установлены в .env файле
// Не используем fallback значения для безопасности
export const dataset = process.env.NEXT_PUBLIC_SANITY_DATASET;
export const projectId = process.env.NEXT_PUBLIC_SANITY_PROJECT_ID;

// Проверяем наличие обязательных переменных
if (!dataset || !projectId) {
  if (typeof window === 'undefined') {
    // На сервере выбрасываем ошибку
    throw new Error(
      'Missing required Sanity environment variables: NEXT_PUBLIC_SANITY_DATASET and NEXT_PUBLIC_SANITY_PROJECT_ID must be set'
    );
  }
  // На клиенте просто предупреждаем (чтобы не ломать сборку)
  console.warn('Sanity environment variables not configured');
}
